import React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, ModalFooter, ModalBody, Label } from 'reactstrap';
import { FieldArray } from 'formik';
import { gql } from 'apollo-boost';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import FormikInputField from '~/components/formikInputField/formikInputField';
import styles from './styles.css';

export const getTrackedIngredientsQuery = gql`
  query ingredients($breweryId: Int!, $isTracked: Boolean) {
    ingredients(breweryId: $breweryId, isTracked: $isTracked) {
      id
      name
      measurementType
      type
      amountOnHand
    }
  }
`;

const CreateStocktakeForm = ({
  onToggle,
  onSuccess,
  brewery,
  isSubmitting,
  ingredients,
  values,
  errors,
  error,
  handleSubmit,
  setFieldValue
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ModalBody>
        {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
        <div className="mb3">
          <Label>Reference (optional)</Label>
          <FormikInputField name="reference" />
        </div>
        <table className="table mb3">
          <thead>
            <tr>
              <th className="bt-n bb-n table-header w-40">Ingredient</th>
              <th className="bt-n bb-n table-header w-30">Current amount</th>
              <th className="bt-n bb-n table-header w-30">New amount</th>
            </tr>
          </thead>
          <tbody>
            <FieldArray
              name="ingredients"
              validateOnChange={false}
              render={arrayHelpers => {
                return ingredients.map((ingredient, idx) => {
                  return (
                    <tr className={`${styles.row} table-row`} key={ingredient.id}>
                      <td className="w-40">{ingredient.name}</td>
                      <td className="w-30">
                        {ingredient.amountOnHand} {ingredient.measurementType.toLowerCase()}
                      </td>
                      <td className="w-30">
                        <FormikInputField className="flex-grow-1" name={`ingredients.${idx}.amount`} />
                      </td>
                    </tr>
                  );
                });
              }}
            />
          </tbody>
        </table>
        <div className="mb3">
          <Label>Notes</Label>
          <FormikInputField type="textarea" name="notes" />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onToggle}>
          Cancel
        </Button>{' '}
        <SubmissionButton color="primary" onClick={() => {}} isSubmitting={isSubmitting}>
          Create
        </SubmissionButton>
      </ModalFooter>
    </form>
  );
};

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(CreateStocktakeForm);



// WEBPACK FOOTER //
// ./src/containers/createStocktakeModal/createStocktakeForm.jsx